<template>
  <div class="special-container-container">
    <!-- 顶部横幅 -->
    <div class="banner-section" :style="bannerStyle">
      <div class="banner-content">
        <h1 class="banner-title">{{ pageData.title || '特种箱杂散运输' }}</h1>
        <p class="banner-subtitle">{{ pageData.subTitle || '专业件杂货运输解决方案，全球网络覆盖' }}</p>
        <div class="banner-desc">{{ pageData.description || '我司拥有专业的件杂货运输船队资源，包含重吊船5条（并吊能力从200T到800T），件杂货船舶共计船只20条，主要分布于南美、印巴、中东、欧洲等航线。' }}</div>
      </div>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container">
      <div class="loading-spinner"></div>
      <p>正在加载数据...</p>
    </div>

    <!-- 错误状态 -->
    <div v-else-if="error" class="error-container">
      <div class="error-icon">⚠️</div>
      <h3>加载失败</h3>
      <p>{{ error }}</p>
      <button @click="fetchData" class="retry-btn">重新加载</button>
    </div>

    <!-- 页面内容 -->
    <div v-else class="page-content">
      <!-- 公司实力 -->
      <div class="company-strength">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">{{ strengthData.title || '公司实力' }}</h2>
            <p class="section-subtitle">{{ strengthData.subTitle || '全方位满足客户多样的货物需求' }}</p>
            <div class="title-decoration"></div>
          </div>
          <div class="strength-content">
            <div class="strength-left">
              <div class="strength-item" v-for="(item, index) in strengthData.items" :key="index">
                <div class="strength-icon">
                  <i :class="item.icon || getStrengthIcon(index)"></i>
                </div>
                <div class="strength-text">
                  <h3>{{ item.title || `实力项${index + 1}` }}</h3>
                  <p>{{ item.description || '专业的实力描述' }}</p>
                </div>
              </div>
            </div>
            <div class="strength-right">
              <div class="strength-image">
                <img :src="strengthData.image || require('../../assets/img/tz/tz01.jpg')" alt="特种箱杂散运输">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 服务优势 -->
      <div class="service-advantages">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">{{ advantagesData.title || $t('specialContainer.services.title') }}</h2>
            <p class="section-subtitle">{{ advantagesData.subTitle || $t('specialContainer.services.subtitle') }}</p>
            <div class="title-decoration"></div>
          </div>
          <div class="advantages-grid">
            <div class="advantage-card" v-for="(advantage, index) in advantagesData.items" :key="index">
              <div class="advantage-icon" :style="{ backgroundColor: getAdvantageColor(index) }">
                <i :class="advantage.icon || getAdvantageIcon(index)"></i>
              </div>
              <h3>{{ advantage.title || `优势${index + 1}` }}</h3>
              <p>{{ advantage.description || '专业的服务优势描述' }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 集装箱代理服务 -->
      <div class="container-agency">
        <div class="container">
          <div class="agency-content">
            <div class="agency-left">
              <h2>{{ agencyData.title || '集装箱代理服务' }}</h2>
              <p>{{ agencyData.description || '集装箱是马士基多航线庄家、YML、PIL、COSCO、CMA、MSC 一级订舱代理' }}</p>
              <div class="agency-partners">
                <div class="partner-logo" v-for="(partner, index) in agencyData.partners" :key="index">
                  <span>{{ partner }}</span>
                </div>
              </div>
            </div>
            <div class="agency-right">
              <img :src="agencyData.image || require('../../assets/img/tz/tz04.jpg')" alt="集装箱代理">
            </div>
          </div>
        </div>
      </div>

      <!-- 项目管理服务 -->
      <div class="project-management">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">{{ projectData.title || '项目管理服务' }}</h2>
            <p class="section-subtitle">{{ projectData.subTitle || '大型工程项目物资管理专家' }}</p>
            <div class="title-decoration"></div>
          </div>
          <div class="project-content">
            <div class="project-left">
              <img :src="projectData.image || require('../../assets/img/tz/tz07.jpg')" alt="项目管理">
            </div>
            <div class="project-right">
              <div class="project-feature" v-for="(feature, index) in projectData.features" :key="index">
                <h3>{{ feature.title || `特点${index + 1}` }}</h3>
                <p>{{ feature.description || '专业的项目管理特点描述' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 公司资质 -->
      <div class="company-qualification">
        <div class="container">
          <div class="qualification-content">
            <div class="qualification-header">
              <h2>{{ qualificationData.title || '上海奥里里亚供应链有限公司' }}</h2>
              <p>{{ qualificationData.description || '经过国家外贸部、民航总局批准成立的一级货运代理物流公司' }}</p>
            </div>
            <div class="qualification-list">
              <div class="qualification-item" v-for="(item, index) in qualificationData.items" :key="index">
                <div class="qualification-icon">
                  <i :class="item.icon || getQualificationIcon(index)"></i>
                </div>
                <div class="qualification-text">
                  <h3>{{ item.title || `资质${index + 1}` }}</h3>
                  <p>{{ item.description || '专业的资质描述' }}</p>
                </div>
              </div>
            </div>
            <div class="qualification-desc">
              <p>{{ qualificationData.detail || '中国国际货运代理协会（CIFA）成员，具备交通部核准颁发的无船承运人（NVOCC）资格和ISO9001质量体系认证，一级航空销售代理人资格（CATA证书）和危险品运输能力。公司综合实力雄厚，在东南亚、中东、南美、欧洲等地区均承接了多区域风电、光伏、燃煤电站、重油机组、垃圾焚烧循环电站、设备车辆运输等多领域项目的物流运输服务。' }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 服务范围 -->
      <div class="service-scope">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">{{ scopeData.title || '服务范围' }}</h2>
            <p class="section-subtitle">{{ scopeData.subTitle || '全方位、综合性国际物流服务' }}</p>
            <div class="title-decoration"></div>
          </div>
          <div class="scope-grid">
            <div class="scope-card" v-for="(item, index) in scopeData.items" :key="index">
              <div class="scope-icon">
                <i :class="item.icon || getScopeIcon(index)"></i>
              </div>
              <h3>{{ item.title || `服务${index + 1}` }}</h3>
              <p>{{ item.description || '专业的服务范围描述' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import { getSpecialContainerData } from '@/api/special-container'

export default {
  name: 'SpecialContainer',
  data() {
    return {
      pageData: {},
      strengthData: {},
      advantagesData: {},
      agencyData: {},
      projectData: {},
      qualificationData: {},
      scopeData: {},
      loading: true,
      error: null
    }
  },
  components: {
    CallMe,
    MobileCallme
  },
  computed: {
    bannerStyle() {
      if (this.pageData.bannerImage) {
        return {
          backgroundImage: `url(${this.pageData.bannerImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }
      }
      return {
        background: 'linear-gradient(135deg, rgba(26, 115, 232, 0.9), rgba(52, 211, 153, 0.8))'
      }
    }
  },
  methods: {
    getStrengthIcon(index) {
      const icons = ['el-icon-ship', 'el-icon-map-location', 'el-icon-check']
      return icons[index] || 'el-icon-star'
    },
    getAdvantageIcon(index) {
      const icons = ['el-icon-time', 'el-icon-lock', 'el-icon-office-building', 'el-icon-global']
      return icons[index] || 'el-icon-star'
    },
    getAdvantageColor(index) {
      const colors = ['#4CAF50', '#2196F3', '#FF9800', '#9C27B0']
      return colors[index] || '#607D8B'
    },
    getQualificationIcon(index) {
      const icons = ['el-icon-document', 'el-icon-medal', 'el-icon-ship', 'el-icon-star']
      return icons[index] || 'el-icon-star'
    },
    getScopeIcon(index) {
      const icons = ['el-icon-truck', 'el-icon-ship', 'el-icon-house', 'el-icon-document-checked', 'el-icon-truck', 'el-icon-management']
      return icons[index] || 'el-icon-service'
    },
    async fetchData() {
      try {
        this.loading = true
        console.log('开始请求特种箱杂散数据...')
        // 获取当前语言
        const currentLanguage = localStorage.getItem('preferred-language') || 'zh-CN'
        console.log('当前语言:', currentLanguage)
        
        const response = await getSpecialContainerData(currentLanguage)
        console.log('特种箱杂散API响应:', response)
        
        // 检查响应结构 - 参考南美专线的处理方式
        if (response.data && response.data.code === 200) {
          console.log('特种箱杂散数据获取成功，数据长度:', response.data.data ? response.data.data.length : 0)
          this.processData(response.data.data)
        } else if (response.data && response.data.data) {
          // 如果后端直接返回数据，没有code字段
          console.log('特种箱杂散数据获取成功（直接数据），数据长度:', response.data.data.length)
          this.processData(response.data.data)
        } else {
          this.error = `获取数据失败: ${response.data?.msg || '未知错误'}`
          console.error('特种箱杂散API返回错误:', response)
        }
      } catch (err) {
        this.error = `网络错误: ${err.message}`
        console.error('获取特种箱杂散数据失败:', err)
      } finally {
        this.loading = false
      }
    },
    processData(data) {
      // 处理字典数据，转换为前端需要的格式
      const dictMap = {}
      data.forEach(item => {
        dictMap[item.dictKey] = item.dictValue
      })

      console.log('处理后的字典数据:', dictMap)

      // 横幅数据 - 使用新的键名
      this.pageData = {
        title: dictMap['special_container_banner_title'],
        subTitle: dictMap['special_container_banner_subtitle'],
        description: dictMap['special_container_banner_description'],
        bannerImage: dictMap['special_container_banner_image']
      }

      // 公司实力数据 - 使用新的键名
      this.strengthData = {
        title: dictMap['special_container_strength_title'],
        subTitle: dictMap['special_container_strength_subtitle'],
        image: dictMap['special_container_strength_image'],
        items: [
          {
            title: dictMap['special_container_strength_item_1_title'],
            description: dictMap['special_container_strength_item_1_desc'],
            icon: dictMap['special_container_strength_item_1_icon']
          },
          {
            title: dictMap['special_container_strength_item_2_title'],
            description: dictMap['special_container_strength_item_2_desc'],
            icon: dictMap['special_container_strength_item_2_icon']
          },
          {
            title: dictMap['special_container_strength_item_3_title'],
            description: dictMap['special_container_strength_item_3_desc'],
            icon: dictMap['special_container_strength_item_3_icon']
          }
        ]
      }

      // 服务优势数据 - 使用新的键名
      this.advantagesData = {
        title: dictMap['special_container_advantages_title'],
        subTitle: dictMap['special_container_advantages_subtitle'],
        items: [
          {
            title: dictMap['special_container_advantage_1_title'],
            description: dictMap['special_container_advantage_1_desc'],
            icon: dictMap['special_container_advantage_1_icon']
          },
          {
            title: dictMap['special_container_advantage_2_title'],
            description: dictMap['special_container_advantage_2_desc'],
            icon: dictMap['special_container_advantage_2_icon']
          },
          {
            title: dictMap['special_container_advantage_3_title'],
            description: dictMap['special_container_advantage_3_desc'],
            icon: dictMap['special_container_advantage_3_icon']
          },
          {
            title: dictMap['special_container_advantage_4_title'],
            description: dictMap['special_container_advantage_4_desc'],
            icon: dictMap['special_container_advantage_4_icon']
          }
        ]
      }

      // 集装箱代理数据 - 使用新的键名
      this.agencyData = {
        title: dictMap['special_container_agency_title'],
        description: dictMap['special_container_agency_description'],
        image: dictMap['special_container_agency_image'],
        partners: [
          dictMap['special_container_partner_1'],
          dictMap['special_container_partner_2'],
          dictMap['special_container_partner_3'],
          dictMap['special_container_partner_4'],
          dictMap['special_container_partner_5'],
          dictMap['special_container_partner_6']
        ]
      }

      // 项目管理数据 - 使用新的键名
      this.projectData = {
        title: dictMap['special_container_project_title'],
        subTitle: dictMap['special_container_project_subtitle'],
        image: dictMap['special_container_project_image'],
        features: [
          {
            title: dictMap['special_container_project_feature_1_title'],
            description: dictMap['special_container_project_feature_1_desc']
          },
          {
            title: dictMap['special_container_project_feature_2_title'],
            description: dictMap['special_container_project_feature_2_desc']
          }
        ]
      }

      // 公司资质数据 - 使用新的键名
      this.qualificationData = {
        title: dictMap['special_container_qualification_title'],
        description: dictMap['special_container_qualification_description'],
        detail: dictMap['special_container_qualification_detail'],
        items: [
          {
            title: dictMap['special_container_qualification_item_1_title'],
            description: dictMap['special_container_qualification_item_1_desc'],
            icon: dictMap['special_container_qualification_item_1_icon']
          },
          {
            title: dictMap['special_container_qualification_item_2_title'],
            description: dictMap['special_container_qualification_item_2_desc'],
            icon: dictMap['special_container_qualification_item_2_icon']
          },
          {
            title: dictMap['special_container_qualification_item_3_title'],
            description: dictMap['special_container_qualification_item_3_desc'],
            icon: dictMap['special_container_qualification_item_3_icon']
          },
          {
            title: dictMap['special_container_qualification_item_4_title'],
            description: dictMap['special_container_qualification_item_4_desc'],
            icon: dictMap['special_container_qualification_item_4_icon']
          }
        ]
      }

      // 服务范围数据 - 使用新的键名
      this.scopeData = {
        title: dictMap['special_container_scope_title'],
        subTitle: dictMap['special_container_scope_subtitle'],
        items: [
          {
            title: dictMap['special_container_scope_item_1_title'],
            description: dictMap['special_container_scope_item_1_desc'],
            icon: dictMap['special_container_scope_item_1_icon']
          },
          {
            title: dictMap['special_container_scope_item_2_title'],
            description: dictMap['special_container_scope_item_2_desc'],
            icon: dictMap['special_container_scope_item_2_icon']
          },
          {
            title: dictMap['special_container_scope_item_3_title'],
            description: dictMap['special_container_scope_item_3_desc'],
            icon: dictMap['special_container_scope_item_3_icon']
          },
          {
            title: dictMap['special_container_scope_item_4_title'],
            description: dictMap['special_container_scope_item_4_desc'],
            icon: dictMap['special_container_scope_item_4_icon']
          },
          {
            title: dictMap['special_container_scope_item_5_title'],
            description: dictMap['special_container_scope_item_5_desc'],
            icon: dictMap['special_container_scope_item_5_icon']
          },
          {
            title: dictMap['special_container_scope_item_6_title'],
            description: dictMap['special_container_scope_item_6_desc'],
            icon: dictMap['special_container_scope_item_6_icon']
          }
        ]
      }
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>

<style lang="scss" scoped>
.special-container-container {
  position: relative;
  overflow-x: hidden;
}

// 横幅区域
.banner-section {
  width: 100%;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
  position: relative;
}

.banner-content {
  max-width: 800px;
  padding: 0 20px;
}

.banner-title {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
}

.banner-subtitle {
  font-size: 1.3rem;
  margin-bottom: 25px;
  opacity: 0.9;
}

.banner-desc {
  font-size: 1.1rem;
  line-height: 1.6;
  opacity: 0.8;
  max-width: 600px;
  margin: 0 auto;
}

// 通用容器
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

// 通用标题样式
.section-header {
  margin-bottom: 40px;
  text-align: center;
}

.section-title {
  font-size: 2rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 15px;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #64748b;
  margin-bottom: 20px;
}

.title-decoration {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #1a73e8, #34d399);
  border-radius: 2px;
  margin: 0 auto;
}

// 内容区域
.page-content {
  padding: 80px 0;
}

.company-strength,
.service-advantages,
.container-agency,
.project-management,
.company-qualification,
.service-scope {
  margin-bottom: 80px;
}

// 公司实力样式
.strength-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.strength-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
}

.strength-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #1a73e8, #34d399);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  margin-right: 20px;
  flex-shrink: 0;
}

.strength-text h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.strength-text p {
  font-size: 1rem;
  line-height: 1.6;
  color: #64748b;
}

.strength-image img {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

// 服务优势样式
.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.advantage-card {
  text-align: center;
  padding: 40px 30px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease;
}

.advantage-card:hover {
  transform: translateY(-5px);
}

.advantage-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2rem;
  margin: 0 auto 20px;
}

.advantage-card h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 15px;
}

.advantage-card p {
  font-size: 1rem;
  line-height: 1.7;
  color: #64748b;
}

// 集装箱代理样式
.container-agency {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 80px 0;
}

.agency-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.agency-left h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 20px;
}

.agency-left p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 30px;
  opacity: 0.9;
}

.agency-partners {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.partner-logo {
  background: rgba(255, 255, 255, 0.1);
  padding: 15px;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
  backdrop-filter: blur(10px);
}

.agency-right img {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
}

// 项目管理样式
.project-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.project-left img {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.project-feature {
  margin-bottom: 40px;
}

.project-feature h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 15px;
}

.project-feature p {
  font-size: 1rem;
  line-height: 1.7;
  color: #64748b;
}

// 公司资质样式
.company-qualification {
  background: #f8fafc;
  padding: 80px 0;
}

.qualification-header {
  text-align: center;
  margin-bottom: 50px;
}

.qualification-header h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 15px;
}

.qualification-header p {
  font-size: 1.1rem;
  color: #64748b;
}

.qualification-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
}

.qualification-item {
  display: flex;
  align-items: flex-start;
  padding: 30px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
}

.qualification-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #1a73e8, #34d399);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.3rem;
  margin-right: 20px;
  flex-shrink: 0;
}

.qualification-text h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.qualification-text p {
  font-size: 1rem;
  line-height: 1.6;
  color: #64748b;
}

.qualification-desc {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.qualification-desc p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #64748b;
}

// 服务范围样式
.scope-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.scope-card {
  text-align: center;
  padding: 40px 30px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease;
}

.scope-card:hover {
  transform: translateY(-5px);
}

.scope-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #1a73e8, #34d399);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.8rem;
  margin: 0 auto 20px;
}

.scope-card h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 15px;
}

.scope-card p {
  font-size: 1rem;
  line-height: 1.7;
  color: #64748b;
}

// 加载状态
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
  text-align: center;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #1a73e8;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.loading-container p {
  font-size: 1.1rem;
  color: #64748b;
}

// 错误状态
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
  text-align: center;
}

.error-icon {
  font-size: 3rem;
  margin-bottom: 20px;
}

.error-container h3 {
  font-size: 1.5rem;
  color: #dc2626;
  margin-bottom: 15px;
}

.error-container p {
  font-size: 1rem;
  color: #64748b;
  margin-bottom: 25px;
  max-width: 400px;
}

.retry-btn {
  background: linear-gradient(135deg, #1a73e8, #34d399);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.retry-btn:hover {
  transform: translateY(-2px);
}

// 动画效果
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

// 响应式设计
@media (max-width: 768px) {
  .banner-section {
    height: 350px;
    padding: 0 20px;
  }
  
  .banner-title {
    font-size: 2rem;
  }
  
  .banner-subtitle {
    font-size: 1rem;
  }
  
  .page-content {
    padding: 50px 0;
  }
  
  .company-strength,
  .service-advantages,
  .container-agency,
  .project-management,
  .company-qualification,
  .service-scope {
    margin-bottom: 50px;
  }
  
  .section-title {
    font-size: 1.5rem;
  }
  
  .strength-content,
  .agency-content,
  .project-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .advantages-grid,
  .scope-grid {
    grid-template-columns: 1fr;
  }
  
  .agency-partners {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .qualification-list {
    grid-template-columns: 1fr;
  }
  
  .qualification-item {
    flex-direction: column;
    text-align: center;
  }
  
  .qualification-icon {
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>
